var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-editor',{attrs:{"permission":"blog","fields":_vm.fields,"publication":true,"updatePossible":true,"endpoint":"blog","previewModule":"blog","module":"blog"},on:{"update":_vm.updateState}})}
var staticRenderFns = []

export { render, staticRenderFns }